// extracted by mini-css-extract-plugin
export default {"l_left":"style_l_left_tvIkR","l_right":"style_l_right_6JWK9","fpic06":"style_fpic06_nnyAP","stockListCon":"style_stockListCon_Nxruv"};